<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import { RECOVERY_SERVICE, RETRY_CREATE_SERVICE } from "@/events/constants";

export default {
  name: "ServiceErrorDialog",
  computed: {
    ...mapGetters("services", ["servicesWithError"]),
    servicesWithErrorCount() {
      return Object.keys(this.servicesWithError).length;
    },
  },
  watch: {
    servicesWithErrorCount(v) {
      if (v > 0) {
        this.$confirm(
          "No se ha podido enviar el servicio, intentalo de nuevo.",
          "Ha ocurrido un error",
          {
            confirmButtonText: "Reintentar",
            cancelButtonText: "Ver el servicio",
            type: "error",
            closeOnPressEscape: false,
            closeOnClickModal: false,
          }
        )
          .then(() => {
            this.$bus.emit(RETRY_CREATE_SERVICE, Object.values(this.servicesWithError)[0]);
          })
          .catch(() => {
            this.$bus.emit(RECOVERY_SERVICE, Object.values(this.servicesWithError)[0]);
          });
      }
    },
  },
};
</script>
